export class InvoiceModel {
	primaryStore = ""

	constructor(data) {
		Object.assign(this, data)
		this.primaryStoreKey = this.storeKey?.[0]
		this.createdAt       = this.invoiceDate
	}
}
